<script>
import FaqApi from "@/services/faq-api";

export default ({

    props: {
        title:{
          type:String,
          default:null
        },

        faqType:{
          type:Number,
          default:null
        },
      
    },

    data() {
        return{
            isCollapsed: []  ,
            faqList: null , 
            open: false
        }
    },
   

  mounted() {
    this.getFaq()
  },

  methods: {

    toggleCollapse(index) {

    this.$set(this.isCollapsed, index, !this.isCollapsed[index]);

    } ,

    getFaq(){
            FaqApi.getFaq(this.faqType).then(
                result => {
                    this.faqList = result
                    this.isCollapsed = new Array(this.faqList.length).fill(false);
                    this.isCollapsed[0] = true ;
                }
            )

        }
      },
      
});

</script>

<template>

<div class="row mt-4">
        <div class="col-12" style="display: contents ;" >
            <div class="col-2" />
            <div class="col-8">
                <div class=" mt-4 mb-4 text-dark font-weight-bold" style="font-size: 34px;" > {{title}}</div>
                    <template>
                    <div class="accordion" id="accordionExample">
                        <div class="card " v-for="(data, index) in faqList" :key="data.id"  style="background-color: transparent; box-shadow: none;">
                        <div class="card-header p-0" :id="'heading' + index" style="background-color: transparent;">
                            <div class="row ">
                                <div class="col-12" style="display: contents;">
                                    <div class="col-11"> 
                                        <button class="btn btn-block text-left text-left font-size-18 text-dark font-weight-bold" type="button" @click="toggleCollapse(index)" :aria-expanded="isCollapsed[index] ? 'true' : 'false'" :aria-controls="'collapse' + index">
                                            {{ data.title }}
                                        </button>
                                    </div>
                                    <div class="col-1"   style="cursor: pointer;" @click="toggleCollapse(index)">
                                        
                                    
                                        <svg v-if="isCollapsed[index] == true" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.65137 14H21.9847" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>

                                        <svg v-else  width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75016 0.833008C9.75016 0.418794 9.41438 0.0830078 9.00016 0.0830078C8.58595 0.0830078 8.25016 0.418794 8.25016 0.833008V8.24967H0.833496C0.419283 8.24967 0.0834961 8.58546 0.0834961 8.99967C0.0834961 9.41389 0.419283 9.74967 0.833496 9.74967H8.25016V17.1663C8.25016 17.5806 8.58595 17.9163 9.00016 17.9163C9.41438 17.9163 9.75016 17.5806 9.75016 17.1663V9.74967H17.1668C17.581 9.74967 17.9168 9.41389 17.9168 8.99967C17.9168 8.58546 17.581 8.24967 17.1668 8.24967H9.75016V0.833008Z" fill="#121212"/>
                                        </svg>

                                    </div>
                                </div>
                            </div>
                            
                        
                        </div>

                        <div :id="'collapse' + index" class="collapse" :class="{ 'show': isCollapsed[index] }" :aria-labelledby="'heading' + index" data-parent="#accordionExample">
                            <div class="card-body font-size-18 pl-3 text-justify" style=" max-width: 90%;">
                            {{ data.description  }}
                            </div>
                        </div>

                        <div class="mt-4  mb-4"   style="border-top: 1px solid rgba(234, 234, 234, 1) "/>       

                        </div>
                    </div>
                    </template>
            </div>
            <div class="col-2" />
        </div>
    </div>
    
</template>

<style scoped>
</style>
